import { type } from '@/utils/type'


export const USER_REQUEST = type('USER_REQUEST')
export const USER_SUCCESS = type('USER_SUCCESS')
export const USER_ERROR = type('USER_ERROR')

export const USER_ENSURE_LIST = type('USER_ENSURE_LIST')

export const USER_SELECT_DETAIL_REQUEST = type('USER_SELECT_DETAIL_REQUEST')
export const USER_SELECT_DETAIL_SUCCESS = type('USER_SELECT_DETAIL_SUCCESS')
export const USER_SELECT_DETAIL_ERROR = type('USER_SELECT_DETAIL_ERROR')
export const USER_SELECT_DETAIL = type('USER_SELECT_DETAIL')

export const USER_SAVE_REQUEST = type('USER_SAVE_REQUEST')
export const USER_SAVE_SUCCESS = type('USER_SAVE_SUCCESS')
export const USER_SAVE_ERROR = type('USER_SAVE_ERROR')

export const USER_DELETE_REQUEST = type('USER_DELETE_REQUEST')
export const USER_DELETE_SUCCESS = type('USER_DELETE_SUCCESS')
export const USER_DELETE_ERROR = type('USER_DELETE_ERROR')

export const USER_EXTERNAL_UPDATE = type('USER_EXTERNAL_UPDATE')
export const USER_ROLEMAPPING_EXTERNAL_UPDATE = type('USER_ROLEMAPPING_EXTERNAL_UPDATE')

export const USER_UPDATE_MODIFIED_ADM = type('USER_UPDATE_MODIFIED_ADM')
export const USER_CANCEL_MODIFIED_ADM = type('USER_CANCEL_MODIFIED_ADM')

export const USER_UPDATE_FILTER_ADM = type('USER_UPDATE_FILTER_ADM')

export const USER_ENSURE_ROLEMAPPING = type('USER_ENSURE_ROLEMAPPING')
export const USER_ROLEMAPPING_REQUEST = type('USER_ROLEMAPPING_REQUEST')
export const USER_ROLEMAPPING_SUCCESS = type('USER_ROLEMAPPING_SUCCESS')
export const USER_ROLEMAPPING_ERROR = type('USER_ROLEMAPPING_ERROR')

export const USER_ADD_ROLEMAPPING_REQUEST = type('USER_ADD_ROLEMAPPING_REQUEST')
export const USER_ADD_ROLEMAPPING_SUCCESS = type('USER_ADD_ROLEMAPPING_SUCCESS')
export const USER_ADD_ROLEMAPPING_ERROR = type('USER_ADD_ROLEMAPPING_ERROR')

export const USER_REMOVE_ROLEMAPPING_REQUEST = type('USER_REMOVE_ROLEMAPPING_REQUEST')
export const USER_REMOVE_ROLEMAPPING_SUCCESS = type('USER_REMOVE_ROLEMAPPING_SUCCESS')
export const USER_REMOVE_ROLEMAPPING_ERROR = type('USER_REMOVE_ROLEMAPPING_ERROR')

export const USER_CHANGE_PASSWORD_REQUEST = type('USER_CHANGE_PASSWORD_REQUEST')
export const USER_CHANGE_PASSWORD_SUCCESS = type('USER_CHANGE_PASSWORD_SUCCESS')
export const USER_CHANGE_PASSWORD_ERROR = type('USER_CHANGE_PASSWORD_ERROR')